import { render, staticRenderFns } from "./Message.vue?vue&type=template&id=17cb2c08&"
import script from "./Message.vue?vue&type=script&lang=js&"
export * from "./Message.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Pipelines\\release\\07.00\\maintenance\\Fontes\\corp\\produto\\wes\\WebApp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17cb2c08')) {
      api.createRecord('17cb2c08', component.options)
    } else {
      api.reload('17cb2c08', component.options)
    }
    module.hot.accept("./Message.vue?vue&type=template&id=17cb2c08&", function () {
      api.rerender('17cb2c08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "content/components/Wes/Message.vue"
export default component.exports